// ============================================
// NETWORK CONFIGURATION
// Change USE_MAINNET to toggle networks
// ============================================
const USE_MAINNET = true;

const MAINNET = {
  chainId: '0x38',
  chainIdDecimal: 56,
  chainName: 'BNB Smart Chain',
  rpcUrls: ['https://bsc-dataseed.binance.org', 'https://bsc-dataseed1.defibit.io', 'https://bsc-dataseed1.ninicoin.io'],
  blockExplorerUrls: ['https://bscscan.com'],
  nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  contractAddress: '0x89a5dc56793CFF4d70D671ebcF833cdA50986Ea3',
  usdtAddress: '0x55d398326f99059ff775485246999027b3197955',
};

const TESTNET = {
  chainId: '0x61',
  chainIdDecimal: 97,
  chainName: 'BNB Smart Chain Testnet',
  rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545', 'https://data-seed-prebsc-2-s1.binance.org:8545'],
  blockExplorerUrls: ['https://testnet.bscscan.com'],
  nativeCurrency: { name: 'tBNB', symbol: 'tBNB', decimals: 18 },
  contractAddress: '0x8a9b0B0525C7e57A577113366b9209251ee6Aa7D',
  usdtAddress: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC',
};

const NETWORK = USE_MAINNET ? MAINNET : TESTNET;

export default NETWORK;
export { USE_MAINNET };
